import type { RouterHook } from '@/types/router/router-hook.type'
import { useAppStore } from '@/stores/app.store'
import { MOBILE_BREAKPOINT } from '@/utils/constants/window'

export const asideCollapsibleHook: RouterHook = {
  beforeEachAuthenticated: async (to) => {
    const { setAsideCollapsable } = useAppStore()

    if (window.screen.width >= MOBILE_BREAKPOINT) {
      const collapsable = Boolean(to.meta.asideCollapsable)
      setAsideCollapsable(collapsable)
    }
  },
}
